app.controller("EditStudentController", ["$scope", "$uibModalInstance", "ProgramService", "Students", "StaticData", "student", "toastr",
    function ($scope, $uibModalInstance, ProgramService, Students, StaticData, student, toastr) {
        $scope.format = "dd-MM-yyyy";
        student.info = student.info || {};
        $scope.faculty = student.info.faculty || null;
        $scope.level = student.info.level || null;
        $scope.subject = student.info.subject || null;
        $scope.semester = student.info.semester ? student.info.semester.toString() : 'სემესტრი';
        if (student.program) $scope.chosenProgram = student.program;
        if (student.info.school) $scope.school = student.info.school;
        if (student.info.graduationYear) $scope.graduationYear = student.info.graduationYear;
        if (student.info.certificateNumber) $scope.certificateNumber = student.info.certificateNumber;
        if (student.info.certificateSeries) $scope.certificateSeries = student.info.certificateSeries;
        if (student.info.certificateDate) $scope.certificateDate = new Date(Date.parse(student.info.certificateDate));
        if (student.info.workPlace) $scope.workPlace = student.info.workPlace;
        if (student.info.workPosition) $scope.workPosition = student.info.workPosition;
        if (student.info.socialStatus) $scope.socialStatus = student.info.socialStatus;
        if (student.info.militaryState) $scope.militaryState = student.info.militaryState;
        if (student.info.achievement) $scope.achievement = student.info.achievement;
        if (student.info.infoSource) $scope.infoSource = student.info.infoSource;
        if (student.info.choiceNumber) $scope.choiceNumber = student.info.choiceNumber;
        else  $scope.choiceNumber = "მერამდენე არჩევანია";

        $scope.semesters = ['სემესტრი'].concat(_.range(1, 15));
        $scope.choiceNumbers = ["მერამდენე არჩევანია"].concat(_.range(1, 15));

        $scope.getPrograms = function (name) {
            if (name.length < 1) {
                return [];
            }
            var params = {};
            params.query = name;
            return ProgramService.list(params).then(function (data) {
                return data.docs;
            });
        };

        $scope.editStudent = function () {
            if(!$scope.level){
                toastr.error('', 'გთხოვთ მიუთითოთ საფეხური');
            } else if($scope.semester == 'სემესტრი'){
                toastr.error('', 'გთხოვთ მიუთითოთ სემესტრი');
            } else if(!$scope.faculty){
                toastr.error('', 'გთხოვთ მიუთითოთ ფაკულტეტი');
            } else {
                student.info.faculty = $scope.faculty;
                student.info.level = $scope.level;
                student.info.semester = $scope.semester === 'სემესტრი' ? undefined : Number.parseInt($scope.semester);
                student.info.school = $scope.school;
                student.info.graduationYear = $scope.graduationYear;
                student.info.certificateNumber = $scope.certificateNumber;
                student.info.certificateSeries = $scope.certificateSeries;
                student.info.certificateDate = $scope.certificateDate;
                student.info.workPlace = $scope.workPlace;
                student.info.workPosition = $scope.workPosition;
                student.info.socialStatus = $scope.socialStatus;
                student.info.militaryState = $scope.militaryState;
                student.info.achievement = $scope.achievement;
                student.info.infoSource = $scope.infoSource;
                student.info.choiceNumber = $scope.choiceNumber;
                student.info.subject = $scope.subject;

                if($scope.chosenProgram) {
                    student.program =  $scope.chosenProgram._id;
                }

                Students.edit(student).then(function () {
                    $uibModalInstance.close();
                }).catch(function (err) {
                    toastr.error('', 'დაფიქსირდა შეცდომა');
                });
            }
        };

        StaticData.getItemsByKey("faculties").then(function (faculties) {
            $scope.faculties = [{name: "ფაკულტეტი"}].concat(faculties);
            $scope.facultiesMap = _.keyBy($scope.faculties, '_id');
        });

        StaticData.getItemsByKey("levels").then(function (levels) {
            $scope.levels = [{name: "საფეხური"}].concat(levels);
            $scope.levelsMap = _.keyBy($scope.levels, '_id');
        });

        StaticData.getItemsByKey("teacher_program_subjects").then(function (subjects) {
            $scope.subjects = [{name: "საგანი"}].concat(subjects);
        });

        StaticData.getItemsByKey("social_statuses").then(function (socialStatuses) {
            $scope.socialStatuses = [{name: "სოციალური სტატუსი"}].concat(socialStatuses);
            $scope.socialStatusesMap = _.keyBy($scope.socialStatuses, '_id');
        });

        StaticData.getItemsByKey("military_state").then(function (militaryStates) {
            $scope.militaryStates = [{name: "სამხედრო ვალდებულება"}].concat(militaryStates);
            $scope.militaryStatesMap = _.keyBy($scope.militaryStates, '_id');
        });

        StaticData.getItemsByKey("info_source").then(function (infoSources) {
            $scope.infoSources = [{name: "საიდან გაიგეთ უნივერსიტეტის შესახებ"}].concat(infoSources);
            $scope.infoSourcesMap = _.keyBy($scope.infoSources, '_id');
        });

        $scope.dateOptions = {
            "is-open": "false",
            dateDisabled: false,
            formatYear: 'yyyy',
            clearText: "წაშლა",
            closeText: "დახურვა",
            currentText: "დღეს",
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
